module.exports = __webpack_public_path__ + "static/media/Avatars_Male-30.f068d6be.png";